<template>
  <div class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-large-size-25">
    <label class="md-head mb-0">{{ label }}</label>
    <div class="md-subtitle mt-0">
      <slot v-if="$slots.default"></slot>
      <p v-else class="mt-0">{{ value }}</p>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ItemView',
    props:{
        label:{
            type:String,
            default:'Label'
        },
        value:{
            type:[String,Number],
            default:''
        }
    }
};
</script>

<style scoped>
    .mb-0 {
        margin-bottom: 0;
    }

    .mt-0 {
        margin-top: 0;
    }
</style>
